import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UserInformationForm from 'shared/account/components/UserInformationForm';
import { getRegisterFormFields } from 'shared/account/reducer';
import { registerUser } from '../actions';
var getDisplayPassword = function getDisplayPassword(match) {
  if (typeof match.params.data !== 'undefined') {
    return true;
  }
  try {
    return !JSON.parse(Buffer.from(decodeURIComponent(match.params.data), 'base64'));
  } catch (error) {
    return true;
  }
};
var RegisterForm = function RegisterForm(_ref) {
  var _URLSearchParams$get;
  var formData = _ref.formData,
    match = _ref.match,
    _ref$onEmailVerificat = _ref.onEmailVerificationRequired,
    onEmailVerificationRequired = _ref$onEmailVerificat === void 0 ? function () {} : _ref$onEmailVerificat,
    _ref$onSuccessfulRegi = _ref.onSuccessfulRegistration,
    onSuccessfulRegistration = _ref$onSuccessfulRegi === void 0 ? function () {} : _ref$onSuccessfulRegi,
    referringUrl = _ref.referringUrl;
  var dispatch = useDispatch();
  var fields = useSelector(getRegisterFormFields);
  var processing = useSelector(function (_ref2) {
    var authentication = _ref2.authentication;
    return authentication.status.processing;
  });
  var displayPassword = getDisplayPassword(match);
  var origin = (_URLSearchParams$get = new URLSearchParams(window.location.search).get('origin')) !== null && _URLSearchParams$get !== void 0 ? _URLSearchParams$get : undefined;
  var handleRegisterUser = function handleRegisterUser(userUpdateRequest) {
    dispatch(registerUser(userUpdateRequest, referringUrl, origin)).then(function () {
      var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var emailVerificationRequired = result.emailVerificationRequired,
        emailVerificationPending = result.emailVerificationPending,
        email = result.email,
        loggedIn = result.loggedIn,
        redirectUri = result.redirectUri;

      // The account was created - or was already there waiting on its link -
      // and cannot be logged into until that link is followed.
      if (emailVerificationRequired) {
        onEmailVerificationRequired(email, emailVerificationPending);
        return;
      }
      if (!loggedIn) {
        return;
      }
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'signupComplete'
        });
      }
      onSuccessfulRegistration(referringUrl || redirectUri || '/');
    });
  };
  return /*#__PURE__*/React.createElement(UserInformationForm, {
    displayPassword: displayPassword,
    fields: fields,
    formData: formData,
    persistData: handleRegisterUser,
    processing: processing,
    testAttribute: "registration-form"
  });
};
export default RegisterForm;